import { render, staticRenderFns } from "./RingCenter.vue?vue&type=template&id=22b5002e&scoped=true"
import script from "./RingCenter.vue?vue&type=script&lang=js"
export * from "./RingCenter.vue?vue&type=script&lang=js"
import style0 from "./RingCenter.vue?vue&type=style&index=0&id=22b5002e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5002e",
  null
  
)

export default component.exports